import PropTypes from 'prop-types';
import { Button } from '@codex/basics';
import { Icon } from '@codex/icons';

import styled from 'styled-components';

const StyledButton = styled(Button)`
   width: 100px;
`;

export default function FiltersToggleButton(props) {
  return (
    <StyledButton
      small
      onClick={props.onClick}
    >
      <Icon icon={'Filter'} />
      {' '}
      {/* TODO: add Filter icon to Codex */}
      &nbsp;
      Filter (
      {props.activeFiltersCount}
      )
    </StyledButton>
  );
}

FiltersToggleButton.displayName = 'FiltersToggleButton';

FiltersToggleButton.propTypes = {
  activeFiltersCount: PropTypes.number,
  onClick: PropTypes.func
};

FiltersToggleButton.defaultProps = {
  activeFiltersCount: 0,
  onClick: () => {}
};
